export const DEPARTURE_DIRECTION = "departure"
export const RETURN_DIRECTION = "return"

export const CURRENCIES = [
  { symbol: "€", code: "EUR" },
  { symbol: "$", code: "USD" },
  { symbol: "₴", code: "UAH" },
  // { symbol: "L", code: "MDL" },
]

export const DEFAULT_CURRENCY = "EUR"
